export default __webpack_public_path__ + "apply612c606.png";